export function createIntercomEvent(name, metadata = {}) {
  try {
    Intercom('trackEvent', name, metadata);
  } catch (e) {
    // Intercom not ready or unavailable
  }
}

export function updateIntercom(settings) {
  try {
    window.Intercom('update', settings);
  } catch (e) {
    // Intercom not ready or unavailable
  }
}
